import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, output, input } from '@angular/core';

import { trackByValue } from '@core/common-legacy';
import { CandidateSharedWith, CandidateSharedWithUserRole } from '@core/sharing-container-types';
import {
  AvatarComponent,
  BoxComponent,
  DividerComponent,
  IconButtonComponent,
  ScrollableDirective,
  ScrollTrapDirective,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-candidate-shared-with-list',
  imports: [
    BoxComponent,
    DividerComponent,
    AvatarComponent,
    IconButtonComponent,
    ScrollableDirective,
    ScrollTrapDirective,
    NgTemplateOutlet,
  ],
  templateUrl: './candidate-shared-with-list.component.html',
  styleUrls: ['./candidate-shared-with-list.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateSharedWithListComponent {
  public readonly sharedWithUsers = input<CandidateSharedWith[]>([]);
  public readonly sharedWithUserRoles = input<CandidateSharedWithUserRole[]>([]);
  public readonly withActions = input<boolean>(false);
  public readonly hasScroll = input(true);

  public stopSharingClick = output<CandidateSharedWith>();

  public trackByValue = trackByValue;
}
